module.exports = __webpack_public_path__ + "img/0.9957788f.png";